// extracted by mini-css-extract-plugin
export default {"gender_chart":"styles_gender_chart__7o7Kz","gender_chart-mini":"styles_gender_chart-mini__1wh1M","title-mini":"styles_title-mini__DHgu+","wrapper":"styles_wrapper__Qec5a"};